import { render, staticRenderFns } from "./directory-companies.vue?vue&type=template&id=1967c065&scoped=true"
import script from "./directory-companies.vue?vue&type=script&lang=js"
export * from "./directory-companies.vue?vue&type=script&lang=js"
import style0 from "./directory-companies.vue?vue&type=style&index=0&id=1967c065&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1967c065",
  null
  
)

export default component.exports